import ReactDOMServer from 'react-dom/server';

export const svgToDataUri = (element: React.ReactElement): string => {
  const markup = ReactDOMServer.renderToString(element);
  const encodedMarkup = encodeURIComponent(markup);
  return `"data:image/svg+xml,${encodedMarkup}"`;
};
